import React from 'react';

import PropTypes from 'prop-types';

import { DiskBadge } from 'apps/auth/components/common/DiskBadge/DiskBadge';
import { getIconName } from 'apps/auth/components/ga/activity/utils';

const ActivityIcon = ({ item = {}, options, flagName = '', diskSize = 'large' }) => {
    const { failedCheque = false } = options;
    const { mobileInfo = {} } = item;
    const avatar = mobileInfo.iconLogoAvatar ? mobileInfo.iconLogoAvatar : item.extra.sender_avatar;

    if (avatar) {
        return <DiskBadge src={avatar} logoSymbol={mobileInfo.iconLogoSymbol} alt="" diskSize={diskSize} flagName={flagName} isDisabled={failedCheque} />;
    }
    return <DiskBadge iconName={getIconName(mobileInfo.icon, item)} diskSize={diskSize} flagName={flagName} isDisabled={failedCheque} />;
};
ActivityIcon.propTypes = {
    item: PropTypes.object,
    options: PropTypes.object,
    flagName: PropTypes.string,
    diskSize: PropTypes.string,
};
export default ActivityIcon;
